"use client";
import { useEffect } from "react";

export function PerformanceMonitor() {
  useEffect(() => {
    // Only run in production
    if (process.env.NODE_ENV !== "production") return;

    // Track Core Web Vitals
    if (typeof window !== "undefined" && "PerformanceObserver" in window) {
      // Largest Contentful Paint (LCP)
      const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];
        console.log("LCP:", lastEntry.startTime);
        
        // Send to analytics if needed
        if (window.gtag) {
          window.gtag("event", "LCP", {
            value: Math.round(lastEntry.startTime),
            event_category: "Web Vitals",
          });
        }
      });
      lcpObserver.observe({ entryTypes: ["largest-contentful-paint"] });

      // First Input Delay (FID)
      const fidObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          console.log("FID:", entry.processingStart - entry.startTime);
          
          if (window.gtag) {
            window.gtag("event", "FID", {
              value: Math.round(entry.processingStart - entry.startTime),
              event_category: "Web Vitals",
            });
          }
        });
      });
      fidObserver.observe({ entryTypes: ["first-input"] });

      // Cumulative Layout Shift (CLS)
      let clsValue = 0;
      const clsObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          if (!entry.hadRecentInput) {
            clsValue += entry.value;
            console.log("CLS:", clsValue);
            
            if (window.gtag) {
              window.gtag("event", "CLS", {
                value: Math.round(clsValue * 1000) / 1000,
                event_category: "Web Vitals",
              });
            }
          }
        });
      });
      clsObserver.observe({ entryTypes: ["layout-shift"] });

      // First Contentful Paint (FCP)
      const fcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const firstEntry = entries[0];
        console.log("FCP:", firstEntry.startTime);
        
        if (window.gtag) {
          window.gtag("event", "FCP", {
            value: Math.round(firstEntry.startTime),
            event_category: "Web Vitals",
          });
        }
      });
      fcpObserver.observe({ entryTypes: ["first-contentful-paint"] });

      // Cleanup
      return () => {
        lcpObserver.disconnect();
        fidObserver.disconnect();
        clsObserver.disconnect();
        fcpObserver.disconnect();
      };
    }
  }, []);

  return null; // This component doesn't render anything
}

// Hook for tracking component load times
export function usePerformanceTracking(componentName) {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      const startTime = performance.now();
      
      return () => {
        const loadTime = performance.now() - startTime;
        console.log(`${componentName} load time:`, Math.round(loadTime), "ms");
      };
    }
  }, [componentName]);
} 